import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Customer, DisplayOrder } from "../../models";
import { Query } from "../../services";
import { UnsafeAction } from "../../actions/UnsafeAction";
/* tslint:disable */
@Injectable()
export class CustomerActions {

	static LOAD_CUSTOMERS = "[CUSTOMER] Load Customers"
	public loadCustomer(): Action {
		return {
			type: CustomerActions.LOAD_CUSTOMERS
		}
	}

	static LOAD_CUSTOMER_BY_ID = "[CUSTOMER] Load Customer by id"
	public loadCustomerById(id: string): UnsafeAction {
		return {
			type: CustomerActions.LOAD_CUSTOMER_BY_ID,
			payload: id
		}
	}

	static CUSTOMER_LOADED = "[CUSTOMER] customer loaded"
	public customerLoaded(customer: Customer): UnsafeAction {
		return {
			type: CustomerActions.CUSTOMER_LOADED,
			payload: customer
		}
	}

	static CUSTOMER_SEARCH = "[CUSTOMER] customer query"
	public search(query: Query): UnsafeAction {
		return {
			type: CustomerActions.CUSTOMER_SEARCH,
			payload: query
		}
	}
	static CUSTOMER_SEARCH_SUCCESS = "[CUSTOMER] customer query success"
	public customerSearchSuccess(customers): UnsafeAction{
		return {
			type: CustomerActions.CUSTOMER_SEARCH_SUCCESS,
			payload: customers
		}
	}

	static INIT_CUSTOMER_FROM_QUERY = "[CUSTOMER] initalize customer from query"
	public initalizeCustomerFromQuery(query: Query): UnsafeAction{
		return {
			type: CustomerActions.INIT_CUSTOMER_FROM_QUERY,
			payload: query
		}
	}

	static SET_ADDRESS_FOR_EDIT = "[CUSTOMER] set address for edit"
	public setAddressForEdit(address): UnsafeAction{
		return {
			type: CustomerActions.SET_ADDRESS_FOR_EDIT,
			payload: address
		}
	}

	static UPDATE_ADDRESS = "[CUSTOMER] update address"
	public updateAddress(address): UnsafeAction{
		return {
			type: CustomerActions.UPDATE_ADDRESS,
			payload: address
		}
	}

	static CREATE_ADDRESS = "[CUSTOMER] create address"
	public createAddress(address): UnsafeAction{
		return {
			type: CustomerActions.CREATE_ADDRESS,
			payload: address
		}
	}

	static ADDRESS_SAVED = "[CUSTOMER] address saved"
	public addressSaved(customer): UnsafeAction{
		return {
			type: CustomerActions.ADDRESS_SAVED,
			payload: customer
		}
	}

	static LOAD_DISPLAY_ORDERS_BY_CUSTOMER_UUID = "[CUSTOMER] load displayOrders by customerUUID"
	public loadDisplayOrdersByCustomerUUID(customerUUID: String): UnsafeAction {
		return {
			type: CustomerActions.LOAD_DISPLAY_ORDERS_BY_CUSTOMER_UUID,
			payload: customerUUID
		}
	}

	static DISPLAY_ORDERS_LOADED = "[CUSTOMER] displayOrders loaded"
	public displayOrdersLoaded(displayOrders: DisplayOrder[]): UnsafeAction {
		return {
			type: CustomerActions.DISPLAY_ORDERS_LOADED,
			payload: displayOrders
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/customer-management/customer.actions.ts